
import { FC, useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import {
  toAbsoluteUrl,
  defaultUserInfos,
  MessageModel,
  UserInfoModel,
  KTIcon
} from '../../helpers'
import { airService } from '@/projects/platform/services/air-service'
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { LocalStorageHelper } from '@/core/helper/local-storage-helper';
import { UserManagement } from '@/core/user/user-management';
import { HttpTransportType, HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { Config } from '@/core/config/config';
import Fancybox from '_metronic/layout/components/fancybox/Fancybox';

type Props = {
  isDrawer?: boolean
}
const ChatInner: FC<Props> = ({ isDrawer = false }) => {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();
  const language = LocalStorageHelper.getSpeechRecognitionLanguage();

  const mode = localStorage.getItem('listenMode');

  const messageContainerRef = useRef<HTMLDivElement | null>(null);
  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [messages, setMessages] = useState<MessageModel[]>([])
  const [isBotTyping, setIsBotTyping] = useState(false);
  const [userInfos] = useState<UserInfoModel[]>(defaultUserInfos)
  const [listenMode, setListenMode] = useState<boolean>(false);
  const [hubConnection, setHubConnection] = useState<HubConnection>()

  useEffect(() => {
    scrolling();
    initSetListenMode();
  }, [])
  useEffect(() => {
    scrolling();
  }, [chatUpdateFlag]);

  useEffect(() => {
    setMessage(transcript);
  }, [transcript])


  useEffect(() => {
    airService.getMessageHistory().then((data) => {
      const prevMessages: MessageModel[] = [];
      for (let index = 0; index < data.searchResult.length; index++) {
        const element = data.searchResult[index];
        const airBotMessage: MessageModel = {
          id: element.id, user: 4, type: element.type, text: element.message, time: 'Just now',
          document: element.document, hasAttachment: element.hasAttachment, documentType: element.documentType, vote: element.vote
        }
        prevMessages.push(airBotMessage);
      }
      setMessages(prevMessages);
      toggleChatUpdateFlat((flag) => !flag)
    }).finally(async () => {
      createHubConnection();
    })
  }, [])

  const createHubConnection = async () => {

    const token = LocalStorageHelper.getAccessToken();
    if (!token) {
      console.error("Token bulunamadı!");
      return;
    }
    const hubCn = new HubConnectionBuilder()
      .withUrl(Config.VITE_SOCKET_GATEWAY_URL, {
        accessTokenFactory: () => token,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .withAutomaticReconnect([0, 5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 55000, 60000])
      .withKeepAliveInterval(30000)
      .build();

    hubCn.onclose((error) => {
      console.error("Bağlantı kesildi:", error);
      hubCn.start()
        .then(() => console.log("Bağlantı kuruldu:", hubCn.state))
        .catch((error) => console.error("Bağlantı başlatılamadı:", error));
    });
    hubCn.onreconnecting((error) => {
      console.warn("Yeniden bağlanılıyor:", error);
    });

    hubCn.onreconnected((connectionId) => {
      console.log("Yeniden bağlandı, Connection ID:", connectionId);
    });
    try {
      hubCn.start()
        .then(() => console.log("Bağlantı kuruldu:", hubCn.state))
        .catch((error) => console.error("Bağlantı başlatılamadı:", error));
      setHubConnection(hubCn);
    } catch (e) {
      console.log("Bağlantı hatası:", e);
    }
  };

  useEffect(() => {
    if (hubConnection) {
      hubConnection.on("ReceiveMessage", (msg: any) => {
        console.log(msg);
        const airBotMessage: MessageModel = {
          id: msg.id, user: 4, type: 'in', text: msg.replyMessage, time: 'Just now',
          document: msg.document, hasAttachment: msg.hasAttachment, documentType: msg.documentType,
          vote: null
        }
        textToSpeech(msg.replyMessage);
        setIsBotTyping(false);
        setMessages(prevMessages => [...prevMessages, airBotMessage])
        toggleChatUpdateFlat((flag) => !flag)
      });
    }
  }, [hubConnection]);

  const speechToText = () => {

    resetTranscript()
    SpeechRecognition.startListening({ language: language, continuous: true });
  }
  const textToSpeech = (txt: any) => {
    let lmode = localStorage.getItem('listenMode');
    if (lmode == 'opened') {
      const refreshIntervalId = setInterval(() => { speechSynthesis.pause(); speechSynthesis.resume(); console.log('runnig'); }, 4000)
      const msg = new SpeechSynthesisUtterance(txt);
      console.log(language);
      msg.lang = language;
      window.speechSynthesis.speak(msg);
      window.speechSynthesis.getVoices()
      msg.onend = () => {
        clearInterval(refreshIntervalId);
      }
    }
    console.log(listenMode);
  }
  const sendMessage = async () => {
    if (message) {
      if (hubConnection) {
        hubConnection.invoke("SendMessage", message).then((res) => { });
        const clientMessage: MessageModel = { user: 2, type: 'out', text: message, time: 'Just now', }
        setMessages(prevMessages => [...prevMessages, clientMessage])
        toggleChatUpdateFlat(!chatUpdateFlag)
        setMessage('')
        setIsBotTyping(true);
      }
    }
  }

  const sendFeedback = async (id: string, vote: boolean | null) => {
    handleVote(id, vote);
    await airService.sendFeedback({ id, vote });
  }

  const handleVote = (id: string, vote: boolean | null) => {
    setMessages((prev) =>
      prev.map((msg) =>
        msg.id === id
          ? { ...msg, vote: vote } // Aynı butona tıklarsa sıfırla
          : msg
      )
    );
  };

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault()
      sendMessage()
    }
  }
  const handleMuteListenMode = () => {
    setListenMode(false);
    localStorage.setItem('listenMode', 'closed');
  }

  const handleOpenListenMode = () => {
    triggerSpeechSynthesisUtterance();
    setListenMode(true);
    localStorage.setItem('listenMode', 'opened');
  }
  const scrolling = async () => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
    }
  }
  const initSetListenMode = async () => {
    if (mode == 'opened') {
      setListenMode(true);
    }
    else {
      setListenMode(false);
    }
  }
  const triggerSpeechSynthesisUtterance = () => {
    //The following codes very important to browsers in ios and ipad.. We have to trigger SpeechSynthesisUtterance code.
    //Please don't remove the following codes.
    const lecture = new SpeechSynthesisUtterance('');
    lecture.volume = 0;
    speechSynthesis.speak(lecture);
  }

  const downloadFile = async (id: any, document: string) => {
    airService.downloadFile(id, document);
  }

  return (
    <div
      className='card-body' id={isDrawer ? 'kt_drawer_chat_messenger_body' : 'kt_chat_messenger_body'}>
      <div
        style={{ height: '77vh' }}
        className={clsx('scroll-y me-n5 pe-5', { 'h-300px h-lg-auto': !isDrawer })}
        data-kt-element='messages'
        data-kt-scroll='true'
        data-kt-scroll-activate='{default: false, lg: true}'
        data-kt-scroll-max-height='auto'
        data-kt-scroll-dependencies={
          isDrawer
            ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
            : '#kt_header, #kt_app_header, #kt_app_toolbar, #kt_toolbar, #kt_footer, #kt_app_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
        }
        data-kt-scroll-wrappers={
          isDrawer
            ? '#kt_drawer_chat_messenger_body'
            : '#kt_content, #kt_app_content, #kt_chat_messenger_body'
        }
        data-kt-scroll-offset={isDrawer ? '0px' : '5px'}
        ref={messageContainerRef}
      >
        {messages.map((message, index) => {
          const userInfo = userInfos[message.user]
          const state = message.type === 'in' ? 'info' : 'primary'
          const templateAttr = {}
          if (message.template) {
            Object.defineProperty(templateAttr, 'data-kt-element', {
              value: `template-${message.type}`,
            })
          }
          const contentClass = `${isDrawer ? '' : 'd-flex'} justify-content-${message.type === 'in' ? 'start' : 'end'
            } mb-10`
          return (
            <div
              key={`message${index}`}
              className={clsx('d-flex', contentClass, 'mb-10', { 'd-none': message.template })}
              {...templateAttr}
            >
              <div
                className={clsx(
                  'd-flex flex-column align-items',
                  `align-items-${message.type === 'in' ? 'start' : 'end'}`
                )}
              >
                <div className='d-flex align-items-center mb-2'>
                  {message.type === 'in' ? (
                    <>
                      <div className='symbol  symbol-35px symbol-circle '>
                        <img alt='Pic' src='/custom/obase-air.png' />
                      </div>
                      <div className='ms-3'>
                        <a className='fs-5 fw-bold text-gray-900 me-1'>
                          {userInfo.name}
                        </a>
                        {/* <span className='text-muted fs-7 mb-1'>{message.time}</span> */}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='me-3'>
                        {/* <span className='text-muted fs-7 mb-1'>{message.time}</span> */}
                        <a className='fs-5 fw-bold text-gray-900 ms-1'>
                          {UserManagement.getName()}
                        </a>
                      </div>
                      <div className='symbol  symbol-35px symbol-circle '>
                        <img alt='Pic' src={UserManagement.getAvatar()} onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = "/logo/07804c87-9a27-4b5b-9092-fadb2f043faf.png";
                        }} />
                      </div>
                    </>
                  )}
                </div>

                <div
                  className={clsx(
                    'p-5 rounded',
                    `bg-light-${state}`,
                    'text-gray-900 fw-semibold mw-lg-400px',
                    `text-${message.type === 'in' ? 'start' : 'end'}`
                  )}
                  data-kt-element='message-text'
                >
                  <div dangerouslySetInnerHTML={{ __html: message.text }} />
                  {message.hasAttachment == 1 && message.documentType === 'png' && message.type === 'in' && (
                    <>
                      <br></br>
                      <Fancybox
                        options={{
                          Carousel: {
                            infinite: false,
                          },
                        }}
                        setFancyboxIsActive={false}
                      >
                        <a data-fancybox="gallery" href={`data:image/png;base64,${message.document}`}>
                          <img
                            alt=""
                            src={`data:image/png;base64,${message.document}`}
                            style={{ width: '100px', height: '100px' }}
                          />
                        </a>
                      </Fancybox>
                    </>
                  )}
                  {message.hasAttachment == 1 && message.documentType === 'pdf' && message.type === 'in' && (
                    <>
                      <a onClick={message.type === 'in' && message.documentType === 'pdf' ? () => downloadFile(message.id, message.document!) : undefined} href='javascript:void(0)'><i className='fa fa-download'></i></a>
                    </>
                  )}
                </div>
                {message.type === 'in' && (<div>
                  {message.vote !== false && (<div
                    className={clsx(
                      'btn btn-sm btn-icon ',
                      `btn${message.vote !== true ? '-active-' : '-'}color-primary`,
                      'text-gray-900 fw-semibold mw-lg-400px',
                      'text-start'
                    )}
                    onClick={async () => { message.id && message.vote == null && await sendFeedback(message.id, true) }}>
                    <KTIcon className='fs-2' iconName='like' />
                  </div>)}

                  {message.vote !== true && (<div
                    className={clsx(
                      'btn btn-sm btn-icon',
                      `btn${message.vote !== false ? '-active-' : '-'}color-danger`,
                      'text-gray-900 fw-semibold mw-lg-400px',
                      `text-${message.vote === false ? 'start' : 'end justify-content-start'}`
                    )}
                    onClick={async () => { message.id && message.vote == null && await sendFeedback(message.id, false) }}>
                    <KTIcon className='fs-2' iconName='dislike' />
                  </div>)}
                </div>)}
              </div>
            </div>
          )
        })}
        {isBotTyping && (
          <div className="d-flex  justify-content-start mb-10 mb-10">
            <div className="d-flex flex-column align-items align-items-start">
              <div className="d-flex align-items-center mb-2">
                <div className="symbol  symbol-35px symbol-circle ">
                  <img alt="Pic" src='/custom/obase-air.png' />
                </div>
                <div className="ms-3">
                  <a className="fs-5 fw-bold text-gray-900 text-hover-primary me-1">Air</a>
                </div>
              </div>
              <div className="p-5 rounded bg-light-info text-gray-900 fw-semibold mw-lg-400px text-start" data-kt-element="message-text">
                <div className="spinner-grow text-primary" role="status" style={{ width: '0.6rem', height: '0.6rem' }} aria-hidden="true" />
                <div className="spinner-grow text-primary" role="status" style={{ width: '0.6rem', height: '0.6rem' }} aria-hidden="true" />
                <div className="spinner-grow text-primary" role="status" style={{ width: '0.6rem', height: '0.6rem' }} aria-hidden="true" />
              </div>
            </div>
          </div>
        )}
      </div>

      <div
        className='card-footer pt-4'
        id={isDrawer ? 'kt_drawer_chat_messenger_footer' : 'kt_chat_messenger_footer'}
      >
        <textarea
          className='form-control form-control-flush mb-3'
          rows={2}
          data-kt-element='input'
          placeholder='Type a message'
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={onEnterPress}
        ></textarea>

        <div className='d-flex flex-stack'>
          <div className='d-flex align-items-center me-2'>
            <button
              className="btn btn-sm btn-icon btn-active-light-primary me-1 btnSpeaking"
              type='button'
              onTouchStart={speechToText}
              onMouseDown={speechToText}
              onTouchEnd={SpeechRecognition.abortListening}
              onTouchCancel={SpeechRecognition.abortListening}
              onMouseUp={SpeechRecognition.abortListening}
            >
              {listening ? <div className="pulse-ring"></div> : ''}
              <i className="bi bi-mic-fill mic-size" style={{ fontSize: '1.5rem' }} aria-hidden="true"></i></button>
            <button
              className='btn btn-sm btn-icon btn-active-light-primary me-1'
              type='button'
            >
              {listenMode === true ? <span className="left-pan" style={{ cursor: 'pointer', marginLeft: '10px' }}><i onClick={handleMuteListenMode} className="bi bi-volume-up-fill" style={{ fontSize: '1.7rem' }}></i></span> : ''}
              {listenMode === false ? <span className="left-pan" style={{ cursor: 'pointer', marginLeft: '10px' }}><i onClick={handleOpenListenMode} className="bi bi-volume-mute-fill" style={{ fontSize: '1.7rem' }}></i></span> : ''}
            </button>
          </div>
          <button
            className='btn btn-primary'
            type='button'
            data-kt-element='send'
            onClick={sendMessage}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  )
}

export { ChatInner }
